var _path, _path2, _path3, _rect, _path4, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _ellipse, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicroBow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m339.11,411.17c-4.81,0-8.2-.53-8.48-.57-20.73-2.72-42.78-11.39-57.63-18.19-12.7-5.81-24.55-13.38-35.22-22.48L79.14,234.57c-53.26-39.83-62.65-94.62-62.74-95.17-12.32-56.99,16.76-92.46,17.06-92.81l.2-.24.31-.02c81.71-6.24,144.75,12.09,183.26,28.56,41.75,17.86,64.48,37.47,64.71,37.67l166.51,144.94c25.55,23.29,28.6,37.2,28.82,38.4l7.78,22.98c7.16,24.27-12.56,32.14-12.76,32.21l-114.05,56.67c-6.59,2.74-13.77,3.4-19.16,3.4ZM34.42,47.8c-2.51,3.19-28.18,37.5-16.54,91.32.09.58,9.41,54.8,62.2,94.28l158.67,135.38c10.57,9.02,22.3,16.5,34.87,22.26,14.75,6.75,36.65,15.37,57.22,18.07.17.02,14.77,2.29,26.8-2.71l114.07-56.68c.83-.32,18.68-7.5,11.93-30.39l-7.82-23.12c-.02-.14-2.66-14.17-28.35-37.59l-166.5-144.93c-.22-.2-22.82-19.68-64.37-37.45-38.29-16.37-100.97-34.58-182.17-28.44Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m470.11,307.46c-.41-1.36-8.43-26.91-33.53-46.39l-134.26-119.37c-.24-.25-24.3-25.38-68.22-48.65-40.52-21.48-106.72-45.73-192.03-39.36l-.38.03-.2.32c-.26.42-26.18,42.69-12.35,86.95.28,1.59,6.31,34.65,36.1,66.77l174.49,152.03c8.06,7.02,16.88,13.15,26.22,18.22,7.02,3.81,14.39,7.36,21.89,10.57,16.54,7.06,34.57,14.01,50.08,14.01,6.84-.01,13.2-1.36,18.72-4.66l108.25-53.08c.63-.21,5.81-2.18,8.61-8.52,3.16-7.17,2.02-16.88-3.39-28.87Zm2.03,28.23c-2.63,6-7.72,7.74-7.77,7.76l-108.45,53.16c-17.45,10.45-43.99.62-67.49-9.41-7.46-3.19-14.78-6.72-21.77-10.51-9.24-5.02-17.97-11.09-25.94-18.03L66.29,206.68c-.7-.76-1.39-1.51-2.06-2.27-.27-.29-.53-.59-.79-.88-1.97-2.24-3.82-4.48-5.56-6.71-.22-.27-.43-.54-.63-.8-22.14-28.61-26.59-55.03-26.63-55.32l-.03-.11c-13.02-41.58,9.62-81.45,11.98-85.43,84.74-6.24,150.5,17.85,190.77,39.18,43.72,23.16,67.66,48.14,67.94,48.44l134.34,119.45c25.3,19.63,32.99,45.44,33.07,45.7l.03.1c5.24,11.58,6.39,20.89,3.42,27.66Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m434.41,403.22l-.73-1.31,18.31-10.25c.92-.57,1.74-1.3,2.42-2.17l27.12-47.97,1.31.74-27.21,48.11c-.8,1.03-1.77,1.9-2.88,2.59l-18.33,10.26Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 361.63,
    y: 419.72,
    width: 76.84,
    height: 1.5,
    transform: "translate(-149.82 234.78) rotate(-27.77)",
    fill: "#292a59",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m330.99,454.92c-.63,0-1.26-.1-1.88-.29l-45.46-14.34c-23.18-8.16-70.32-46.97-70.79-47.36L51.13,238.36c-.43-.42-10.24-10.21-13.37-18.92-.12-.22-15.47-30.73-20.56-76.25l1.49-.17c5.05,45.23,20.29,75.52,20.44,75.82,3.05,8.47,12.94,18.34,13.04,18.44l161.67,154.52c.43.35,47.37,38.99,70.27,47.06l45.44,14.33c1.18.37,2.44.27,3.54-.29l34.06-15.97.64,1.36-34.04,15.96c-.87.44-1.81.66-2.77.66Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 317.61,
    y: 431.24,
    width: 45.28,
    height: 1.5,
    transform: "translate(-174.11 626.46) rotate(-72.49)",
    fill: "#292a59",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m70.18,109.24c-6.26,11.8-10.29,50.08-2.27,81.41l-1.37.69c-8.14-31.43-4.15-70.03,2.14-82.46l-26.87-54.04,1.35-.67,27.2,54.73-.18.34Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m76.4,215.56l-1.34.68c-.19-.39-4.43-8.86-5.72-14.81.45-.25.92-.51,1.38-.76,1.12,5.76,5.63,14.8,5.68,14.89Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m198.37,128c-.15.09-.31.17-.47.26,0,0,.27-.19.42-.27h0s.03,0,.04.01Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m430.46,321.23l-1.69-1.99h.01s-153.79-146.49-153.79-146.49c-13.91-14.28-46.98-35.1-75.34-44.38-.47.28-.97.59-1.52.88-.1.05-.19.1-.29.16,28.44,8.97,62.08,30,76.1,44.41l153.62,146.33,1.81,2.13.16.14c.14.09,13.9,9.46,18.05,29l1.47-.31c-4.11-19.31-17.36-29-18.6-29.87Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m186.46,125.44c-41.77-11.8-116.23-15.77-116.98-15.81l.08-1.5c.75.04,75.38,4.02,117.31,15.86l-.41,1.44Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m170.53,207.24l-.06,1c-.12-.01-12.05-.76-15.6-1.19-4.38-.53-12.83-4.5-21.76-8.7-9.38-4.4-19.08-8.96-23.73-9.28-1.04-.07-2.75,0-4.26.06-.72.03-1.39.06-1.94.07-.06.47-.23,1.13-.73,1.64-.47.49-1.11.73-1.91.73-.98,0-1.6-.87-1.72-2.37-.63,0-1.23-.03-1.82-.05-2.85-.09-5.12-.17-8.16,1.33l-3.04,3.02c-2.32,1.39-4.77,2.33-7.38,3.33-1.54.59-4.65,2.17-7.7,3.84-.46.25-.93.51-1.38.76-1.99,1.11-3.85,2.19-5.11,2.98-.27-.29-.53-.59-.79-.88,3.51-2.2,11.77-6.54,14.62-7.64,2.55-.97,4.95-1.89,7.17-3.22l3.09-3.05c3.3-1.65,5.81-1.56,8.72-1.47.72.03,1.47.05,2.27.05h.5v.5c0,.2.02,1.87.73,1.87.52,0,.91-.14,1.19-.42.49-.51.48-1.34.48-1.43l-.02-.52h.52c.61,0,1.44-.03,2.37-.07,1.54-.06,3.28-.13,4.36-.05,4.85.33,14.63,4.92,24.09,9.37,8.47,3.98,17.24,8.09,21.46,8.61,3.52.42,15.42,1.18,15.54,1.18Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m78,185.77l-1.77,1.49c-.21.27-.54.55-.92.77l-17.43,8.79c-.22-.27-.43-.54-.63-.8l9.29-4.68,1.37-.69,6.9-3.48c.27-.16.51-.36.72-.61l1.83-1.56.64.77Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m170.46,200.25c-.11,0-10.65-.83-14.16-1.29-3.61-.47-10.12-3.62-17.67-7.27-10.54-5.1-22.5-10.88-29.72-10.88-.69-.02-1.44,0-2.21.01-1.53.01-2.98.02-3.56-.01l-.64-.04.2-.61c.23-.71.28-2.4-.07-2.68-.22-.17-.43-.22-.66-.15-.49.14-.95.74-1.05,1.01l-.11.3c-.48,1.33-.51,1.41-.78,1.52l-.2.09-.28-.1c-.3,0-.8,0-1.38,0-2.39-.03-6.83-.08-8.13.29-.72.21-3.71,1.3-5.17,2.9l-.74-.67c1.59-1.75,4.68-2.92,5.64-3.19,1.33-.38,4.89-.37,8.42-.32.55,0,1.02.01,1.37.01.07-.19.18-.48.31-.86l.11-.3c.18-.51.86-1.38,1.71-1.63.55-.16,1.09-.04,1.56.33.75.59.69,2.19.54,3.14.72.01,1.82,0,2.9,0,.78,0,1.6,0,2.22-.01,7.45,0,19.51,5.84,30.15,10.98,7.15,3.46,13.91,6.73,17.36,7.18,3.48.46,14,1.28,14.11,1.29l-.08,1Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m190.44,133.69c0,.4-.04.82-.09,1.27h0s0,.01,0,.01c-.36.23-.73.45-1.1.67-1.84,1.12-3.02,1.91-2.63,2.7.65,1.86.56,3.33-.23,4.09-.36.35-1.01.66-2.09.38-.22.68-.68,1.49-1.22,2.46-1.21,2.17-2.73,4.88-2.36,7.5.45,3.23,7.13,21.44,9.38,27.35l-.93.36c-1.45-3.81-8.93-23.94-9.44-27.57-.42-2.95,1.26-5.95,2.48-8.13.57-1.01,1.06-1.89,1.2-2.49.02-.07.03-.13.04-.19l.08-.65.6.25c.1.04.2.07.31.1.45.15.95.2,1.26-.1.47-.45.47-1.62,0-2.97-.14-.28-.2-.56-.18-.81,0-.38.18-.74.45-1.08.23-.29.53-.56.88-.83.33-.25.71-.5,1.1-.75.26-.15.52-.31.78-.47.23-.14.46-.28.68-.42.36-.22.72-.45,1.04-.68Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m77.98,196.82l-.99-.14c.63-4.48-3.61-7.84-3.65-7.87l.61-.79c.19.15,4.74,3.74,4.03,8.8Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m80.23,195.99l-1-.08c.41-5.14-3.92-8.15-3.97-8.18l.56-.83c.2.13,4.86,3.35,4.4,9.09Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m83.94,194.3l-.97-.23c.4-1.71-.34-2.88-.37-2.93l.83-.55c.04.06,1.02,1.56.51,3.71Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m86.93,191.93l-1-.06c.28-4.46-3.92-8.1-3.96-8.14l.65-.76c.19.16,4.62,4,4.31,8.96Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m87.48,190.78c-.14-5.14-4.45-8.5-4.49-8.54l.61-.79c.19.15,4.73,3.68,4.88,9.3l-1,.03Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m95.03,171.37c-.49,0-1.15.27-1.57.52,0,0-6.28,3.97-10.03,5.87-.75.38-1.77,1.77-2.35,2.67,0,0-4.75-.02-3.9,4.84.15.87,1.47,1.64,2.5,1.64.99,0,.99-.06,1.74-.81.58-.58-.02-1.25,1.38-2.54.5-.46.54-1.16.78-1.67,1.34-2.74,6.72-5.82,11.68-7.69.62-.23,1.12-.62,1.34-1.24.23-.67.1-1.56-1.57-1.57Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m192.76,122.08s.37.18.83.48c-.35.18-.71.36-1.05.53-.13-.07-.2-.11-.21-.11l.43-.9Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m196.52,129s0,0-.02,0v-.02s.01.01.02.01Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m205.45,123.53h0c-.01-.12-.03-.24-.05-.36-.31-1.74-1.55-3.96-3.36-5.12-.13-.08-.26-.16-.39-.23-.15-.08-.29-.15-.44-.21h-.03s-.18-.09-.18-.09h-.03s-.23.14-.23.14c-1.31.87-2.77,1.59-4.18,2.29-.41.2-.83.41-1.25.62-.03.02-.07.03-.1.05-.54.25-1.2.59-1.89.95-.56.29-1.14.58-1.67.84,0,0-.01,0-.02,0-.37-1.15-2.27-2.24-4.4-1.3-.3.13-.5.41-.64.71-.09.2-.46.37-1.63.16-.53-.1-1.08,0-1.53.3-1.95,1.26-7.25,4.63-9.58,5.56-.69.28-1.16.97-1.07,1.71.05.41.25.77.79.89.2.05.76.11,1.23,0,.53-.13.81-.45,1.14-.68,1.41-1.01,6.84-4.86,9.08-5.28.63-.12.98.05,1.27.32-1.56,1.18-3,2-4.27,2.72-2.71,1.54-4.87,2.76-5.74,6.35-.92.35-3.8,1.62-3.41,3.74.11.58.42,1.04.9,1.32.3.17.66.27,1.03.29-.62,1.34-1.95,4.32-3.04,9.65-.62,3.07-.46,4.92-.31,5.75.49,2.65,8.78,25.1,9.13,26.06l.94-.35c-.09-.23-8.61-23.33-9.09-25.9-.14-.76-.29-2.46.3-5.37,1.09-5.38,2.4-8.2,3.02-9.55.16-.35.28-.6.33-.76l.3-.95-.95.33c-.4.14-.86.12-1.17-.07-.23-.13-.37-.34-.42-.64-.29-1.58,2.97-2.69,3.01-2.7l.27-.09.06-.28c.73-3.36,2.55-4.4,5.31-5.97.84-.48,1.79-1.03,2.78-1.69h.02s.42.21.42.21c1.82.86,4.07,1.93,3.66,7.47,0,.16-.02.33-.04.5l.98.1h0c.65-.43,1.27-.88,1.79-1.41,1.21-1.69,3.56-3,5.71-4.14.1-.06.19-.11.29-.16.55-.29,1.58-.92,1.64-.95,2.28-1.3,5.06-3.06,5.26-3.2.08-.07.15-.16.21-.26.06-.09.1-.2.13-.31.09-.28.11-.62.07-1.01Zm-14.07,9.38c-.27.27-.59.53-.94.78.18-5.49-2.28-6.75-4.17-7.64,0,0-.01,0-.02,0,.24-.17.48-.33.72-.52.46.44,1.14.84,2.61.77.81-.04.68-.73,1.11-1.38.13-.19.3-.37.47-.56.47.29,3.66,2.37,3.59,5.68-1.35.84-2.58,1.78-3.37,2.89Zm5.12-3.9c-.25.13-.51.27-.76.42-.27-3.58-3.55-5.66-4.01-5.93.25-.13.53-.26.81-.41.8.45,3.63,2.25,3.93,5.5.02.13.02.26.03.4.01,0,.01.01.02.01t-.02,0Zm7.93-4.69s-6.89,4.13-6.96,4.17c-.03-.28-.07-.55-.13-.81-.56-2.69-2.59-4.36-3.75-5.12.07-.04,6.17-3.08,7.47-3.92,1.91.94,3.1,3.28,3.36,4.7.04.23.05.42.05.57,0,.27-.04.39-.04.41Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m185.63,138.09c-4.35-6.48-10.31-2.71-10.57-2.55l-.55-.84c.07-.05,7.04-4.48,11.94,2.83l-.83.56Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m184.37,142.65l-.99-.13c.2-1.51-.08-2.72-.84-3.59-.81-.93-2.01-1.27-2.79-1.28-.03,0-.06,0-.08,0-3.18,0-3.56,1.33-3.56,1.34l-.98-.2c.02-.09.46-2.14,4.54-2.14.03,0,.06,0,.09,0,1.04,0,2.51.44,3.54,1.62.66.76,1.38,2.13,1.08,4.38Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m102.21,188.73c-.02-.27-.41-6.63.75-9.29l.92.4c-1.07,2.44-.67,8.77-.67,8.83l-1,.06Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m98.83,189.31c-.04-.27-.93-6.68,1.17-11.19l.91.42c-1.97,4.25-1.1,10.57-1.09,10.63l-.99.14Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m97.12,188.99c-.93-5.34.4-9.34.45-9.51l.95.32s-1.3,3.94-.42,9.02l-.98.17Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m187.83,136.18l-.99-.14c.53-3.71-.12-4.95-.13-4.96l.86-.51c.09.14.84,1.52.26,5.61Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m205.07,124.96l-.55-.84,3.83-2.5c.29-.26.51-.66.57-1.1.1-.72-.07-1.73-.18-2.4-.04-.22-.07-.42-.08-.56-.07-.55-.45-1.03-.97-1.21-1.65-.57-2.7-.14-2.75-.12l-3.44,2.15-.53-.85,3.5-2.19c.12-.06,1.48-.65,3.54.06.88.31,1.52,1.1,1.63,2.04.02.13.05.31.08.52.12.73.3,1.84.18,2.7-.09.67-.43,1.3-.95,1.76l-3.89,2.55Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m207.98,122.97l-.91-.42c.06-.12.17-.61.2-.86.1-.72-.07-1.73-.18-2.4-.04-.22-.07-.42-.08-.56-.07-.55-.45-1.03-.97-1.21-1.67-.58-3.03-.08-3.05-.08l-.36-.93c.07-.03,1.7-.64,3.74.07.88.31,1.52,1.1,1.63,2.04.02.13.05.31.08.52.12.73.3,1.84.18,2.7-.03.19-.15.85-.28,1.14Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m207.03,124.68c-.61,0-1.24-.06-1.9-.2l.2-.98c4.43.92,7.8-2.06,8.45-3.99,1.09-3.26.9-5.49-.57-6.61-3.5-2.66-7.7-.44-7.74-.41-3.24,1.91-3.31,5.18-3.31,5.32h-1c0-.16.05-3.98,3.81-6.19.21-.11,4.83-2.57,8.84.49,1.85,1.41,2.16,4.01.91,7.72-.61,1.83-3.48,4.85-7.7,4.85Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m46.83,215.84c-.19,0-.38-.02-.57-.06-1.68-.36-2.71-2.22-2.3-4.15h0c.41-1.93,2.12-3.2,3.79-2.84.84.18,1.54.73,1.97,1.54.41.77.52,1.7.33,2.61-.37,1.71-1.75,2.9-3.22,2.9Zm-1.4-3.9h0c-.24,1.12.27,2.18,1.14,2.37.87.19,1.77-.57,2.01-1.69.12-.57.05-1.13-.19-1.59-.22-.42-.56-.69-.96-.78-.87-.18-1.77.57-2.01,1.69Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.01,
    cy: 212.29,
    rx: 1.31,
    ry: 1.09,
    transform: "translate(-170.42 213.76) rotate(-77.9)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m189.75,210.17c-1.2,0-2.47-.63-3.39-1.79l-.49-.03c-.56-.03-1.12-.34-1.5-.84l-3.84-4.88c-.5-.61-.61-1.42-.27-2.01l-4.38-5.13c-1.37-1.57-2.29-3.41-2.73-5.45-.21-1-.53-3.46,1.15-4.86l7.51-5.36c1.69-1.21,4.2-.97,5.78.5.38-.21.94-.49,1.26-.55.84-.14,1.98.22,2.55.81l4.41,4.16c.45.55.63,1.17.56,1.78l-.37,1.57,6.66,8.3c1.28,1.9,1,4.38-.59,5.67l-.16,1.32c-.14,1.18-.74,2.21-1.64,2.83l-4.88,3.3c-.72.48-1.61.66-2.52.49l-1.53-.29c-.49.29-1.03.44-1.6.44Zm-5.44-30.11c-.69,0-1.37.19-1.91.58l-7.48,5.33c-1.26,1.06-.92,3.22-.78,3.86.4,1.88,1.25,3.56,2.5,5.01l4.85,5.68-.36.61c-.13.23-.06.59.18.88l3.86,4.89c.21.27.49.44.76.46l.96.05.14.19c1.06,1.45,2.83,1.99,3.93,1.2l.17-.12,1.94.36c.65.12,1.27,0,1.78-.33l4.88-3.3c.66-.45,1.1-1.22,1.21-2.12l.21-1.75.18-.13c1.31-.94,1.55-2.91.55-4.4l-6.94-8.65.47-1.98c.03-.29-.08-.65-.31-.94l-4.38-4.13c-.36-.37-1.18-.62-1.68-.53-.18.03-.79.34-1.26.62l-.35.21-.27-.3c-.72-.8-1.79-1.23-2.83-1.23Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m189.83,207.53c-.15,0-.31-.01-.47-.04-.88-.14-1.72-.66-2.35-1.44l-.36-.02c-.48-.03-.97-.3-1.29-.74l-3.35-4.02c-.43-.53-.53-1.22-.26-1.73l-3.54-4.37c-.86-.96-1.85-2.12-2.53-3.23-.74-1.22-1.2-2.31-1.33-4.27-.12-1.86,1.35-3.45,1.75-3.77l.63.78c-.4.32-1.47,1.61-1.38,2.92.11,1.77.5,2.71,1.18,3.82.64,1.04,1.59,2.15,2.44,3.1l3.99,4.92-.32.55c-.08.14-.06.4.14.65l3.36,4.04c.16.22.37.35.56.36l.83.04.14.19c.48.67,1.16,1.12,1.85,1.24.46.08.89-.01,1.23-.26l.17-.13,1.62.31c.5.09.99,0,1.37-.26l3.99-2.75c.55-.38,1.18-1.16,1.26-1.86l.26-1.69.17-.12c.71-.51,1.17-2.3.5-5l.97-.24c.78,3.18.13,5.12-.71,5.91l-.2,1.28c-.12,1.03-.96,2.05-1.69,2.55l-3.99,2.75c-.61.42-1.36.56-2.13.42l-1.21-.23c-.39.23-.84.35-1.32.35Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m189.26,218.43c-1.2,0-2.47-.63-3.39-1.79l-.49-.03c-.56-.03-1.12-.34-1.5-.84l-3.84-4.88c-.65-.73-.63-1.62-.56-2.07l-4.76-5.62c-1.17-1.32-1.75-2.89-1.73-4.66l1-.11v.13c-.02,1.51.48,2.86,1.48,4l5.09,6.01-.07.26s-.22.83.31,1.43l3.87,4.9c.21.27.49.44.76.46l.96.05.14.19c1.06,1.45,2.83,1.99,3.93,1.2l.17-.12,2.48.41c.67.12,1.28,0,1.79-.33l7.51-5.5.59.81-7.53,5.51c-.73.49-1.63.67-2.53.5l-2.07-.34c-.49.3-1.04.44-1.6.44Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m188.76,220.72c-1.44,0-3.09-.71-4.04-1.87l-.49-.03c-.56-.03-1.12-.35-1.5-.84l-3.93-4.98c-.48-.57-1.47-1.77-1.19-2.91l.05-.13-3.83-4.41c-1.12-.98-1.49-2.12-1.75-3.11-.76-2.94.43-5.25.88-6.12.06-.11.1-.2.13-.26l.92.38c-.03.08-.09.19-.16.33-.44.85-1.46,2.84-.8,5.41.23.89.53,1.82,1.49,2.66l4.26,4.9-.23.63c-.14.6.66,1.56,1.01,1.97l.1.12,3.85,4.89c.21.27.49.44.76.46l.96.05.14.19c1.05,1.44,3.32,1.99,4.44,1.43.3-.15.6-.2.88-.16l1.26.21c.71.13,2.5-.05,2.96-.36l8.58-5.72c.33-.24.58-.67.64-1.14.06-.49-.08-.98-.38-1.35l-1.67-1.64.7-.71,1.71,1.68c.52.62.74,1.39.64,2.15-.1.75-.5,1.43-1.09,1.85l-.67.39-7.89,5.32c-.75.5-2.82.68-3.69.52l-1.25-.21c-.07-.01-.16.01-.27.07-.44.22-.96.32-1.5.32Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m173.34,188.58c-1-.76-1.58-1.81-1.58-2.9,0-2.33,2.04-4.35,4.75-4.69,1.97-.25,3.29.5,3.34.53l-.5.86s-1.1-.61-2.71-.41c-2.21.28-3.88,1.87-3.88,3.7,0,.77.43,1.53,1.18,2.1l-.6.8Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m180.78,181.36s-1.02-.69-2.84-.83l.08-1c2.11.17,3.29.98,3.34,1.01l-.57.82Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m173.25,190.68c-1.76-.98-3.09-3.12-3.09-4.97,0-1.54.7-3.04,1.97-4.22,1.54-1.42,3.69-2.14,5.88-1.97l-.08,1c-1.93-.16-3.79.47-5.12,1.7-1.06.98-1.65,2.22-1.65,3.48,0,1.49,1.13,3.29,2.58,4.1l-.49.87Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 172.99,
    y: 188.47,
    width: 1,
    height: 10.36,
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 176.27,
    y: 204.77,
    width: 8.17,
    height: 1,
    transform: "translate(-34.8 373.7) rotate(-86.75)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 182.08,
    y: 211.52,
    width: 8.28,
    height: 1,
    transform: "translate(-42.64 377.11) rotate(-84.51)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 186.48,
    y: 213.07,
    width: 8.76,
    height: 1,
    transform: "translate(-38.66 384.92) rotate(-84.96)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 189.84,
    y: 213.2,
    width: 8.47,
    height: 1,
    transform: "translate(-32.04 393.16) rotate(-86.19)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 196.64,
    y: 208.43,
    width: 8.79,
    height: 1,
    transform: "translate(-15.21 402.08) rotate(-87.87)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 196.42,
    y: 205.29,
    width: 12.59,
    height: 1,
    transform: "translate(-10.45 400.74) rotate(-87.87)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m188.15,209.62c-.03-.07-.6-1.69.41-2.91l.77.64c-.64.77-.24,1.92-.24,1.94l-.94.34Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m185.12,207.86c-.02-.07-.43-1.75.69-2.86l.7.71c-.7.7-.42,1.89-.42,1.9l-.97.25Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m174.26,193.1c-.02-.07-.45-1.84,1.01-2.69l.51.86c-.81.48-.55,1.57-.54,1.58l-.97.25Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m181.07,201.71l-.98-.19c.11-.59.67-1.74,1.96-1.87l.1.99c-.87.09-1.07,1.03-1.08,1.07Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m194.24,209.59l-.95-.31c.32-.97-.46-1.88-.47-1.89l.75-.66c.05.05,1.16,1.33.67,2.86Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m202.23,200.11c-.31-.95-1.38-1.08-1.39-1.08l.11-.99c.07,0,1.72.2,2.23,1.76l-.95.31Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m200.41,204.65c-.01-.99-1.45-1.65-1.46-1.65l.4-.92c.08.04,2.04.91,2.06,2.56h-1Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m173.17,195.16c-1.89-.32-2.89-1.85-2.93-1.92l-.08-.12v-7.32h1v7.02c.24.31.99,1.16,2.18,1.36l-.17.99Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m173.94,210.32c-2.04,0-3.32-1.51-3.73-2.37l-.05-.22v-8.58h1v8.46c.23.4,1.21,1.92,3.16,1.68l.12.99c-.17.02-.33.03-.49.03Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m172.31,199.88c-3.45-.18-4.1-2.69-4.13-2.8v-.12s-.01-3.86-.01-3.86h1v3.79c.1.3.72,1.86,3.19,1.99l-.05,1Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m173.46,197.61c-2.89-.21-4.77-2.26-5.14-3.57-.66-2.37,1.07-4.14,2.08-4.75l.52.85c-.09.06-2.25,1.41-1.64,3.63.24.87,1.78,2.66,4.25,2.84l-.07,1Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m180.95,218.89l-5.53-6.96c-1.19-1.21-1.89-2.19-1.84-3.54l.11-2.95,1,.04-.11,2.95c-.04.99.53,1.77,1.58,2.84l5.56,7-.78.62Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m174.96,208.68c.44.54.89,1.09,1.33,1.63.06.08.13.16.19.23.12.15.4.14.53,0,.15-.16.13-.37,0-.53-.44-.54-.89-1.09-1.33-1.63-.06-.08-.13-.16-.19-.23-.12-.15-.4-.14-.53,0-.15.16-.13.37,0,.53h0Z",
    fill: "#0069b2",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroBow);
export default __webpack_public_path__ + "static/media/MicroBow.6f4a0a0e046f6e64dff33e3029169d7f.svg";
export { ForwardRef as ReactComponent };